import React from 'react';
import FeatherIcon from '../FeatherIcon';
import { COMPARISON, OFFERED, formatPrice } from '../../products/editions';

/** Feature-by-edition table. It scrolls sideways inside its own box on a narrow screen. */
const EditionComparison: React.FC = () => (
  <section id="compare" aria-labelledby="compare-heading" className="py-16">
    <div className="container max-w-3xl mx-auto px-6">
      <h2 id="compare-heading" className="text-3xl font-bold mb-8 text-center text-gray-800">Compare the Editions</h2>
      <div className="card overflow-x-auto" role="region" aria-labelledby="compare-heading" tabIndex={0}>
        <table className="w-full min-w-[420px] text-sm">
          <caption className="sr-only">Features included in each proposed edition of The Pawsitive Deck</caption>
          <thead>
            <tr className="border-b border-line">
              <th scope="col" className="sticky left-0 bg-card p-4 text-left font-semibold text-gray-800">Feature</th>
              {OFFERED.map((edition) => (
                <th key={edition.id} scope="col" className="p-4 text-center font-semibold text-gray-800">
                  {edition.shortName}
                  <span className="block font-normal text-gray-600">{formatPrice(edition.priceCents)}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARISON.map((row) => (
              <tr key={row.feature} className="border-b border-line last:border-0">
                <th scope="row" className="sticky left-0 bg-card p-4 text-left font-normal text-gray-700">{row.feature}</th>
                {OFFERED.map((edition) => {
                  const included = row.editions.includes(edition.id);
                  return (
                    <td key={edition.id} className="p-4 text-center">
                      {included ? (
                        <FeatherIcon name="check" size={18} className="inline-flex text-secondary" />
                      ) : (
                        <span className="text-gray-400" aria-hidden="true">—</span>
                      )}
                      <span className="sr-only">{included ? 'Yes' : 'No'}</span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default EditionComparison;
